import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import homeBackground from "../assets/img/fondo-home.png";
import "../styles/ComitesTecnicos.css";

function ComitesTecnicos() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [comites, setComites] = useState([]);

  useEffect(() => {
    const fetchSiteConfig = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/site-config/");
        if (!data?.comites_visible) {
          navigate("/");
          return;
        }
        setComites(Array.isArray(data?.comites_json) ? data.comites_json : []);
      } catch (error) {
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchSiteConfig();
  }, [navigate]);

  if (loading) {
    return (
      <div className="comites-loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="comites-page">
      <div
        className="comites-hero"
        style={{ backgroundImage: `url(${homeBackground})` }}
      >
        <div className="comites-hero-overlay">
          <h1 className="comites-hero-titulo">Comités Técnicos</h1>
          <p className="comites-hero-subtitulo">
            Órganos especializados que orientan el desarrollo técnico,
            científico y normativo de la ingeniería sanitaria y ambiental.
          </p>
        </div>
      </div>

      <div className="comites-lista">
        {comites.length === 0 ? (
          <p className="comites-empty">
            Próximamente información sobre nuestros comités técnicos.
          </p>
        ) : (
          comites.map((comite, i) => (
            <div key={i} className={`comite-item ${i % 2 === 0 ? "par" : "impar"}`}>
              <div className="comite-numero">0{i + 1}</div>
              <div className="comite-contenido">
                <h2 className="comite-titulo">{comite.titulo}</h2>
                <div className="comite-divider"></div>
                <p className="comite-descripcion">{comite.descripcion}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ComitesTecnicos;
